import React from 'react';
export function ExpoSocialLinks({ links }) {
  return <nav className="expo-social-links" aria-label="Follow Let The Beat Build">
    {['instagram','facebook','youtube'].filter((key)=>links[key]).map((key)=><a key={key} href={links[key]} target="_blank" rel="noreferrer"><img src={`/brand/${key}.png`} alt="" width="24" height="24"/><span>{({instagram:'Instagram',facebook:'Facebook',youtube:'YouTube'})[key]}</span></a>)}
  </nav>;
}
